import { type Question, QUESTION_TYPE } from '@/@types/onboarding';

const skillsQuestion: Question = {
  id: 1,
  type: QUESTION_TYPE.skills,
  title: 'What are your gardening skills?',
  analytic_key: 'question_skills',
  answers: [
    {
      id: 1,
      title: 'Plant Padawan',
      description: 'Beginner',
      image: require('@/assets/onboarding/skill-beginner.svg'),
      analytic_key: 'answer_skills_beginner',
    },
    {
      id: 2,
      title: 'Plant Whisperer',
      description: 'Enthusiast',
      image: require('@/assets/onboarding/skill-enthusiast.svg'),
      analytic_key: 'answer_skills_enthusiast',
    },
    {
      id: 3,
      title: 'Botanic Maestro',
      description: 'Experienced',
      image: require('@/assets/onboarding/skill-experienced.svg'),
      analytic_key: 'answer_skills_experienced',
    },
    {
      id: 4,
      title: 'Garden Guru',
      description: 'Anvanced',
      image: require('@/assets/onboarding/skill-guru.svg'),
      analytic_key: 'answer_skills_guru',
    },
  ],
};

const plantsHelpQuestion: Question = {
  id: 2,
  type: QUESTION_TYPE.checkbox,
  title: 'Which plants do you need help with?',
  analytic_key: 'question_plants_help',
  answers: [
    {
      id: 1,
      title: 'Indoor Plants',
      description: 'Snake Plant, Monstera',
      image: require('@/assets/onboarding/plant-indoor.png'),
      analytic_key: 'answer_plants_help_indoor',
    },
    {
      id: 2,
      title: 'Flowering Plants',
      description: 'Orchid, Rose, Lily',
      image: require('@/assets/onboarding/plant-flowering.png'),
      analytic_key: 'answer_plants_help_flowering',
    },
    {
      id: 3,
      title: 'Succulents & Cactuses',
      description: 'Jade plant, Aloe Vera',
      image: require('@/assets/onboarding/plant-succulents.png'),
      analytic_key: 'answer_plants_help_succulents',
    },
    {
      id: 4,
      title: 'Herbs',
      description: 'Basil, Rosemary, Mint',
      image: require('@/assets/onboarding/plant-herbs.png'),
      analytic_key: 'answer_plants_help_herbs',
    },
    {
      id: 5,
      title: 'Outdoor Plants',
      description: 'Fruit Trees, Climbing Plants',
      image: require('@/assets/onboarding/plant-outdoor.png'),
      analytic_key: 'answer_plants_help_outdoor',
    },
  ],
};

const timeCareQuestion: Question = {
  id: 3,
  type: QUESTION_TYPE.radio,
  title: 'How much time do you have for weekly plant care?',
  analytic_key: 'question_time_care',
  answers: [
    {
      id: 1,
      title: 'Up to 30 min',
      image: require('@/assets/onboarding/time-sm.png'),
      analytic_key: 'answer_time_care_sm',
    },
    {
      id: 2,
      title: '30 min - 1 hour',
      image: require('@/assets/onboarding/time-md.png'),
      analytic_key: 'answer_time_care_md',
    },
    {
      id: 3,
      title: '1 - 3 hours',
      image: require('@/assets/onboarding/time-lg.png'),
      analytic_key: 'answer_time_care_lg',
    },
    {
      id: 4,
      title: 'More then 3 hours',
      image: require('@/assets/onboarding/time-xl.png'),
      analytic_key: 'answer_time_care_xl',
    },
  ],
};

const plantsCountQuestion: Question = {
  id: 4,
  type: QUESTION_TYPE.radio,
  title: 'How many plants do you have?',
  analytic_key: 'question_plants_count',
  answers: [
    {
      id: 1,
      title: 'Less than 3 plants',
      image: require('@/assets/onboarding/plants-count-sm.png'),
      analytic_key: 'answer_plants_count_sm',
    },
    {
      id: 2,
      title: 'From 3 to 10 plants',
      image: require('@/assets/onboarding/plants-count-md.png'),
      analytic_key: 'answer_plants_count_md',
    },
    {
      id: 3,
      title: 'More than 10 plants',
      image: require('@/assets/onboarding/plants-count-lg.png'),
      analytic_key: 'answer_plants_count_lg',
    },
  ],
};

const plantGoalsQuestion: Question = {
  id: 5,
  type: QUESTION_TYPE.checkbox,
  title: 'Do you have any plant goals?',
  analytic_key: 'question_plant_goals',
  answers: [
    {
      id: 1,
      title: 'Yes, I dream of creating a lush urban jungle in my living space',
      analytic_key: 'answer_plant_goals_urban_jungle',
    },
    {
      id: 2,
      title: 'I aspire to cultivate a collection of rare and exotic flowers',
      analytic_key: 'answer_plant_goals_exotic_flowers',
    },
    {
      id: 3,
      title: 'I have a vision of transforming my backyard into a serene oasis',
      analytic_key: 'answer_plant_goals_serene_oasis',
    },
    {
      id: 4,
      title: "I'm passionate about growing herbs and spices",
      analytic_key: 'answer_plant_goals_growing_herbs',
    },
    {
      id: 5,
      title: "Nope, I'm just curious about how to take care of plants",
      analytic_key: 'answer_plant_goals_take_care',
      resetOther: true,
    },
  ],
};

const plantCareQuestion: Question = {
  id: 6,
  type: QUESTION_TYPE.checkbox,
  title: 'Which plant care activities are challenging for you?',
  analytic_key: 'question_plant_care',
  answers: [
    {
      id: 1,
      title: 'Providing sunlight and water',
      image: require('@/assets/onboarding/plant-care-water.png'),
      analytic_key: 'answer_plant_care_water',
    },
    {
      id: 2,
      title: 'Determining soil type and fertilization',
      image: require('@/assets/onboarding/plant-care-fertilization.png'),
      analytic_key: 'answer_plant_care_fertilization',
    },
    {
      id: 3,
      title: 'Pruning or trimming',
      image: require('@/assets/onboarding/plant-care-trimming.png'),
      analytic_key: 'answer_plant_care_trimming',
    },
    {
      id: 4,
      title: 'Propagating or repotting',
      image: require('@/assets/onboarding/plant-care-repotting.png'),
      analytic_key: 'answer_plant_care_repotting',
    },
  ],
};

const lookingQuestion: Question = {
  id: 7,
  type: QUESTION_TYPE.checkbox,
  title: 'What are you looking for?',
  analytic_key: 'question_looking',
  answers: [
    {
      id: 1,
      title: 'Plant Identification',
      image: require('@/assets/onboarding/looking-identification.png'),
      analytic_key: 'answer_looking_identification',
    },
    {
      id: 2,
      title: 'Care reminders & progress tracking',
      image: require('@/assets/onboarding/looking-progress-tracking.png'),
      analytic_key: 'answer_looking_progress_tracking',
    },
    {
      id: 3,
      title: 'Plant diseases diagnose',
      image: require('@/assets/onboarding/looking-diagnose.png'),
      analytic_key: 'answer_looking_diagnose',
    },
    {
      id: 4,
      title: 'Plant community',
      image: require('@/assets/onboarding/looking-community.png'),
      analytic_key: 'answer_looking_community',
    },
    {
      id: 5,
      title: 'Other',
      image: require('@/assets/onboarding/looking-other.png'),
      analytic_key: 'answer_looking_other',
    },
  ],
};

const identifyPlantQuestion: Question = {
  id: 8,
  type: QUESTION_TYPE.identify,
  title: 'Identify your plant',
  analytic_key: 'question_identify_plant',
};

const identifyPlantQuestion2: Question = {
  id: 9,
  type: QUESTION_TYPE.identify,
  title: 'Identify your plant',
  analytic_key: 'question_identify_plant',
};

const emailQuestion: Question = {
  id: 10,
  type: QUESTION_TYPE.email,
  title: 'Enter your email to access your plant care routine',
  analytic_key: 'question_email',
};

export const baseQuestions: Question[] = [
  skillsQuestion,
  plantsHelpQuestion,
  timeCareQuestion,
  plantsCountQuestion,
  plantGoalsQuestion,
  plantCareQuestion,
  lookingQuestion,
  identifyPlantQuestion,
  identifyPlantQuestion2,
  emailQuestion,
];
